import GearCircuitryIcon from './GearCircuitryIcon'

export default GearCircuitryIcon
